import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FaireItem } from './ren-faire.model';

@Injectable({ providedIn: 'root' })
export class RenFaireService {
  private injector = inject(EnvironmentInjector);

  constructor(private db: AngularFireDatabase) {}

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getItems(): Observable<FaireItem[]> {
    return this.inCtx(() => this.db.list<FaireItem>('ren-faire/items').snapshotChanges().pipe(
      map(actions => actions.map(a => ({
        id: a.key,
        ...(a.payload.val() as FaireItem)
      })))
    ));
  }

  addItem(item: FaireItem): Promise<void> {
    return this.inCtx(() => this.db.object(`ren-faire/items/${item.id}`).set(item));
  }

  updateItem(item: FaireItem): Promise<void> {
    return this.inCtx(() => this.db.object(`ren-faire/items/${item.id}`).set(item));
  }

  deleteItem(id: string): Promise<void> {
    return this.inCtx(() => this.db.object(`ren-faire/items/${id}`).remove());
  }
}
